import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var EditSVG = function EditSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M19 7.3l-16 16a1.15 1.15 0 00-.14.17l-.08.17a.62.62 0 00-.07.23l-.71 5A1 1 0 003 30h.14l5-.71a1 1 0 00.41-.16l.17-.13 16-16zM29.7 6.58L25.42 2.3a1 1 0 00-.71-.3 1 1 0 00-.72.3l-3.56 3.57 5.71 5.71L29.7 8a1 1 0 000-1.42z"
  }));
};
EditSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(EditSVG);